"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentInfosOrderDetailsToJSON = exports.ShipmentInfosOrderDetailsFromJSONTyped = exports.ShipmentInfosOrderDetailsFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ShipmentInfosOrderDetailsFromJSON(json) {
    return ShipmentInfosOrderDetailsFromJSONTyped(json, false);
}
exports.ShipmentInfosOrderDetailsFromJSON = ShipmentInfosOrderDetailsFromJSON;
function ShipmentInfosOrderDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'cancelable': !(0, runtime_1.exists)(json, 'cancelable') ? undefined : json['cancelable'],
        'orderDetailId': !(0, runtime_1.exists)(json, 'orderDetailId') ? undefined : json['orderDetailId'],
        'orderDate': json['orderDate'],
        'paymentType': !(0, runtime_1.exists)(json, 'paymentType') ? undefined : json['paymentType'],
        'deliveryAddress': !(0, runtime_1.exists)(json, 'deliveryAddress') ? undefined : (0, _1.ShipmentAddressFromJSON)(json['deliveryAddress']),
        'isShippingToBillingAddress': !(0, runtime_1.exists)(json, 'isShippingToBillingAddress') ? undefined : json['isShippingToBillingAddress'],
        'carrier': !(0, runtime_1.exists)(json, 'carrier') ? undefined : json['carrier'],
        'deliveryService': !(0, runtime_1.exists)(json, 'deliveryService') ? undefined : json['deliveryService'],
        'packageType': !(0, runtime_1.exists)(json, 'packageType') ? undefined : json['packageType'],
        'numberOfPackages': !(0, runtime_1.exists)(json, 'numberOfPackages') ? undefined : json['numberOfPackages'],
        'completeDelivery': !(0, runtime_1.exists)(json, 'completeDelivery') ? undefined : json['completeDelivery'],
        'unifiedInvoiceId': !(0, runtime_1.exists)(json, 'unifiedInvoiceId') ? undefined : json['unifiedInvoiceId'],
        'invoiceUrl': !(0, runtime_1.exists)(json, 'invoiceUrl') ? undefined : json['invoiceUrl'],
        'returnInformation': !(0, runtime_1.exists)(json, 'returnInformation') ? undefined : (0, _1.ShipmentInfosOrderDetailsReturnInformationFromJSON)(json['returnInformation']),
    };
}
exports.ShipmentInfosOrderDetailsFromJSONTyped = ShipmentInfosOrderDetailsFromJSONTyped;
function ShipmentInfosOrderDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'cancelable': value.cancelable,
        'orderDetailId': value.orderDetailId,
        'orderDate': value.orderDate,
        'paymentType': value.paymentType,
        'deliveryAddress': (0, _1.ShipmentAddressToJSON)(value.deliveryAddress),
        'isShippingToBillingAddress': value.isShippingToBillingAddress,
        'carrier': value.carrier,
        'deliveryService': value.deliveryService,
        'packageType': value.packageType,
        'numberOfPackages': value.numberOfPackages,
        'completeDelivery': value.completeDelivery,
        'unifiedInvoiceId': value.unifiedInvoiceId,
        'invoiceUrl': value.invoiceUrl,
        'returnInformation': (0, _1.ShipmentInfosOrderDetailsReturnInformationToJSON)(value.returnInformation),
    };
}
exports.ShipmentInfosOrderDetailsToJSON = ShipmentInfosOrderDetailsToJSON;
//# sourceMappingURL=ShipmentInfosOrderDetails.js.map